import * as React from 'react';
import { Controller } from 'react-hook-form';
import Input from '@/components/Input/Input';
import { HookFormProps } from './HookFormProps';

export const ControlledInput: React.FC<HookFormProps> = ({ onEnter, from, scrollContainer = '.main-container-desktop', scrollToTop, scrollToBottom, ...props }: any) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      defaultValue={props.defaultValue ?? ''}
      render={({ field: { onChange, name: fieldName, value }, fieldState: { error } }) => {
        return (
          <Input
            {...props}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onChange(e);
              props.onChange && props.onChange(e);
            }}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                onEnter && onEnter(e);
              }
            }}
            onFocus={(e) => {
              if (scrollToTop) {
                document.querySelector(scrollContainer).scrollTop = e.target.offsetTop;
                // console.log('focus', scrollToTop, document.body.scrollTop, e.target.offsetTop);
              }
            }}
            name={fieldName}
            error={error && error.message}
            value={value ?? ''}
          />
        );
      }}
    />
  );
};
